import { db } from '../firebase';
import { getBackendError } from 'common/utils';
import { isDefined, isDefinedAndNotEmpty, isEmpty } from 'check-tool';

const userAnswerMapper = (documentSnapshot) => {
  const { answerUid, dateModified, isCorrect, questionUid, subcategoryUid, userUid, deviceToken } = documentSnapshot.data();

  let dateModifiedLocal = dateModified ? new Date(dateModified.seconds * 1000).toLocaleString('en-US') : '-';
  dateModifiedLocal = dateModifiedLocal !== '-' ? dateModifiedLocal.substring(0, dateModifiedLocal.length - 3) : '-';
  let dateModifiedShortLocal = dateModifiedLocal !== '-' ? dateModifiedLocal.substring(0, dateModifiedLocal.length - 7) : '-';
  return {
    id: documentSnapshot.id,
    answerUid,
    dateModified: dateModifiedLocal,
    dateModifiedShort: dateModifiedShortLocal,
    isCorrect,
    questionUid,
    subcategoryUid,
    userUid,
    deviceToken,
  };
};

const userAnswerListMapper = (docs) => {
  return docs.map((documentSnapshot) => userAnswerMapper(documentSnapshot));
};

export const getLastTimeAnswers = (userUid, subcategoryUid) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user-answer')
      .where('userUid', '==',  userUid)
      .orderBy('dateModified', 'desc')
      .get()
      .then((querySnapshot) => {
        const result = userAnswerListMapper(querySnapshot.docs);
        let resultQbj = {
          'lastTimeAnswer': '--',
          'totalQuestions': 0,
          'totalSubcategory': 0,
        };
        if (isDefinedAndNotEmpty(result) && result.length > 0) {
          let subcategoryArr = [];
          let totalSubcategoryArr = 0;
          resultQbj.lastTimeAnswer = result[0].dateModified;
          resultQbj.totalQuestions = result.length;
          result.map((element) => {
            if (!isDefined(subcategoryArr[element.subcategoryUid])) {
              subcategoryArr[element.subcategoryUid] = [];
              totalSubcategoryArr++;
            }
            subcategoryArr[element.subcategoryUid].push(element)
          });
          resultQbj.totalSubcategory = totalSubcategoryArr;
          resolve(resultQbj);
        } else {
          resolve(resultQbj);
        }
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getAllUserAnswers = () => {
  return new Promise((resolve, reject) => {
    db
      .collection('user-answer')
      .limit(10)
      .get()
      .then((querySnapshot) => {
        const result = userAnswerListMapper(querySnapshot.docs);
        let resultQbj = {
          'totalUser': 0,
          'totalNotUser': 0,
          'data': [],
        };
        if (isDefinedAndNotEmpty(result) && result.length > 0) {
          let data = [];
          let totalUser = 0;
          let totalNotUser = 0;
          result.map((element) => {
            if (!isDefined(data[element.dateModifiedShort])) {
              data[element.dateModifiedShort] = [];
            }
            if (isEmpty(element.userUid)) {
              if (!isDefined(data[element.dateModifiedShort]['dataNotUser'])) {
                data[element.dateModifiedShort]['dataNotUser'] = [];
              }
              if (!isDefined(data[element.dateModifiedShort]['dataNotUser'][element.deviceToken])) {
                data[element.dateModifiedShort]['dataNotUser'][element.deviceToken] = [];
              }
              if (!isDefined(data[element.dateModifiedShort]['dataNotUser'][element.deviceToken][element.subcategoryUid])) {
                data[element.dateModifiedShort]['dataNotUser'][element.deviceToken][element.subcategoryUid] = [];
                totalNotUser++;
              }
              data[element.dateModifiedShort]['dataNotUser'][element.deviceToken][element.subcategoryUid].push(element);
            } else {
              if (!isDefined(data[element.dateModifiedShort]['dataUser'])) {
                data[element.dateModifiedShort]['dataUser'] = [];
              }
              if (!isDefined(data[element.dateModifiedShort]['dataUser'][element.userUid])) {
                data[element.dateModifiedShort]['dataUser'][element.userUid] = [];
              }
              if (!isDefined(data[element.dateModifiedShort]['dataUser'][element.userUid][element.subcategoryUid])) {
                data[element.dateModifiedShort]['dataUser'][element.userUid][element.subcategoryUid] = [];
                totalUser++;
              }
              data[element.dateModifiedShort]['dataUser'][element.userUid][element.subcategoryUid].push(element);
            }
          });
          
          resolve(resultQbj);
        } else {
          resolve(resultQbj);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(getBackendError(error));
      });
  });
};